<template>
  <div class="childSubfunc">
    <label v-for="(navMenu) in navMenus" :key="navMenu.menuId">
      <el-submenu
          v-if="navMenu.children&&navMenu.children.length>0"
          :index="navMenu.menuUrl"
          :key="navMenu.menuId">
        <template slot="title">
          <i :class="navMenu.menuIcon" style="color:#428BCA"></i>
          <span slot="title">{{ navMenu.menuName }}</span>
        </template>
        <el-menu-item-group class="childSubfuncGroup">
          <NavMenu :navMenus="navMenu.children"></NavMenu>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item
          v-else
          :key="navMenu.menuId" :data="navMenu" :index="navMenu.menuUrl" :route="navMenu.routeurl">
        <!-- <i style="height: 15px;width: 15px;" :class="navMenu.funcimg"></i>  -->

        <span slot="title">{{ navMenu.funcname }}</span>
      </el-menu-item>
    </label>
  </div>
</template>
<script>
import VueCookies from "vue-cookies"

export default {
  name: 'NavMenu',
  props: ['navMenus'],
  data() {
    return {
      cusUrl: process.env.API_ROOT,
      access_token: VueCookies.get("access_token"),
    }
  },
  methods: {
    openNewpage(data) {
      window.open(this.cusUrl + '/gcsite/toFineReport?reportName=' + data + '&access_token=' + this.access_token)
    }
  }
}
</script>
<style scoped lang="scss">
.openPage {
  padding-left: 40px;
  height: 50px;
  line-height: 50px;
  min-width: 200px;
  background: #F6F7FB;
  box-sizing: border-box;
  cursor: pointer;
}

.openPage:hover {
  background-image: linear-gradient(179deg, #FF8D7E 0%, #FF523B 95%);
  color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// NavMenu.vue?5c7a9a8a